<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>ID/비밀번호 찾기</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>ID/비밀번호 찾기</h2>
      </div>
    </div>

    <div class="contents">
      <div class="joinWrap">
        <h3 class="conTit" v-if="state.sType == 1">ID 찾기</h3>
        <h3 class="conTit" v-if="state.sType == 2">
          본인 인증(비밀번호 초기화)
        </h3>

        <div class="chkType" v-if="state.sType == 1">
          <a @click="athType('id')" class="btn active"><span>ID</span></a>
          <a @click="athType('pwd')" class="btn"><span>비밀번호</span></a>
        </div>
        <div class="chkType" v-if="state.sType == 2">
          <a @click="athType('id')" class="btn"><span>ID</span></a>
          <a @click="athType('pwd')" class="btn active"
            ><span>비밀번호</span></a
          >
        </div>
        <div class="tabStyle1">
          <table>
            <caption>
              ID 찾기
            </caption>
            <colgroup>
              <col width="142" />
              <col width="*" />
            </colgroup>
            <tbody v-if="state.sType == 1">
              <tr>
                <th scope="row">사업자번호</th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      v-on:input="
                        $event.target.value = $event.target.value.replace(
                          /[^0-9]/g,
                          ''
                        )
                      "
                      v-model="state.corpNo"
                      maxlength="10"
                      placeholder="-없이 연속 10자리 입력"
                      title="사업자번호"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">담당자명</th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      v-model="state.logNm"
                      placeholder="이름을 입력해 주세요"
                      title="담당자명"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">담당자 생년월일</th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      v-on:input="
                        $event.target.value = $event.target.value.replace(
                          /[^0-9]/g,
                          ''
                        )
                      "
                      maxlength="8"
                      v-model="state.logbirth"
                      v
                      placeholder="-없이 입력해 주세요"
                      title="담당자 생년월일"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="state.sType == 2">
              <tr>
                <th scope="row">성명</th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      v-model="state.name"
                      placeholder="성명 입력"
                      title="성명"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">생년월일</th>
                <td>
                  <div class="typeSplit5">
                    <div class="inpTxt">
                      <input
                        type="text"
                        v-on:input="
                          $event.target.value = $event.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )
                        "
                        v-model="state.birth_ymd"
                        maxlength="8"
                        placeholder="예) 19800101(8자리)"
                        title="생년월일"
                      />
                    </div>
                    -
                    <div class="inpTxt">
                      <input
                        type="text"
                        style="width: 65px"
                        v-model="state.gndr"
                        maxlength="1"
                        title="성별"
                      /><span> xxxxxx</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">통신사</th>
                <td>
                  <div class="inpSlt">
                    <button type="button" class="sltBtn">
                      <span>SKT</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.getPhoneTypCd"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('PhoneTypCd', item)"
                        >
                          <span>{{ item.name }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">휴대폰번호</th>
                <td>
                  <div class="typeSplit5">
                    <div class="inpTxt">
                      <input
                        type="text"
                        v-on:input="
                          $event.target.value = $event.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )
                        "
                        v-model="state.phoneNum"
                        placeholder="'-'없이 입력하세요"
                        maxlength="11"
                        title="휴대폰번호"
                      />
                    </div>
                    <a @click="getNum()" class="btnType sizeS colorR"
                      ><span>인증번호받기</span></a
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">인증번호</th>
                <td>
                  <div class="typeSplit5">
                    <div class="inpTxt">
                      <input
                        type="text"
                        v-model="state.getInNum"
                        title="인증번호"
                      />
                      <span>* 휴대폰으로 보내드린 인증번호를 입력하세요.</span>
                    </div>
                    <div class="txt_time">
                      <span>남은시간:{{ timer.remainAthHr }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="btnWrap mgt30">
          <a @click="lostChk()" class="btnType sizeS colorB"
            ><span>인증</span></a
          >
        </div>
      </div>
    </div>
  </div>
  <PopPwChange ref="PopPwChangeRef" @close="handlePopupClose"></PopPwChange>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  inject,
  onMounted,
  computed,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import PopPwChange from "@/components/common/layerPop/PopPwChange.vue";
import * as codeList from "@/common/code";

const PopPwChangeRef = ref(null);
const swalAlert = inject("swalAlert");
const axios = inject("axios");
const state = reactive({
  currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
  rtrnAnimInsYn: false,
  mode: process.env.NODE_ENV,
  athTypeCd: 1,
  currDate: util.formatDate(new Date(), "yyyymmdd"),
  sType: 1,
  logId: "",
  logNm: "",
  logbirth: "",
  corpNo: "",
  getPhoneTypCd: [],
  PhoneTypCd: "1",
  name: "",
  birth_ymd: "",
  phoneNum: "",
  getInNum: "",
  gndr: "",

  athInhrNo: "",
  biz_no: "",
  lostPwBcOutputVo: [],
});

const onSelectEvent = (selectId, data) => {
  if (selectId == "PhoneTypCd") {
    state.PhoneTypCd = data.code;
  }
};

const getNum = () => {
  if (state.birth_ymd.substring(0, 4) >= "2000") {
    if (state.gndr < 3) {
      return swalAlert("생년월일을 확인해 주세요");
    }
  }

  if (_.isEmpty(state.name)) {
    return swalAlert("성명을 입력해주세요.");
  } else if (_.isEmpty(state.birth_ymd) || _.isEmpty(state.gndr)) {
    return swalAlert("생년월일을 입력해주세요.");
  } else if (_.isEmpty(state.phoneNum)) {
    return swalAlert("휴대폰 번호를 입력해주세요.");
  } else if (state.birth_ymd.substring(0, 4) >= "2000") {
    if (state.gndr < 3) {
      return swalAlert("생년월일을 확인해 주세요");
    }
  }

  let param = {};
  param.fnm = state.name;
  param.bdt = state.birth_ymd;
  param.ccoDiv = state.PhoneTypCd;
  param.cellNo = state.phoneNum;
  param.gndr = state.gndr;
  param.biz = "gnr";

  console.log(param);

  axios.json("/mobAth/rqeMobAth.do", param).then(function (result) {
    state.athInhrNo = result.data.athInhrNo;
    timer.athInhrNo = result.data.athInhrNo; //인증고유번호
    if (result.data.state == "Y") {
      start_timer();
      swalAlert(result.data.msg);
      timer.timerFlag = true;
    } else {
      swalAlert(result.data.msg);
      timer.timerFlag = false;
    }
  });
};

const athType = (type) => {
  switch (type) {
    case "id":
      state.sType = 1;
      state.logId = "";
      state.logNm = "";
      state.logbirth = "";
      state.corpNo = "";
      break;
    case "pwd":
      state.sType = 2;
      state.logId = "";
      state.logNm = "";
      state.logbirth = "";
      state.corpNo = "";
      break;
  }
};
const lostChk = () => {
  //아이디 찾기
  if (state.sType == 1) {
    let param = {};
    param.logNm = state.logNm;
    param.logbirth = state.logbirth;
    param.corpNo = state.corpNo;
    param.page = window.location.hash;

    if (_.isEmpty(state.corpNo)) {
      return swalAlert("사업자번호를 입력해주세요.");
    } else if (_.isEmpty(state.logNm)) {
      return swalAlert("담당자명을 입력해주세요.");
    } else if (_.isEmpty(state.logbirth)) {
      return swalAlert("생년월일을 입력해주세요.");
    } else if (state.logbirth.length != 8) {
      return swalAlert("생년월일을 8자리 입력해주세요.");
    }
    axios.json("/findId.do", param).then(function (result) {
      swalAlert(result.data.msg);
    });
  } else {
    //인증 번호 확인

    if (!timer.timerFlag) {
      return swalAlert(
        "인증시간이 만료되었습니다.\n\n인증번호 재발송 하신 후 진행하세요."
      );
    } else if (util.isNull(state.getInNum) || util.isEmpty(state.getInNum)) {
      return swalAlert("인증번호를 입력해주세요.");
    }

    let param = {};
    param.athInhrNo = state.athInhrNo;
    param.smsAthNo = state.getInNum;

    axios.json("/mobAth/cnfMobAth.do", param).then(async function (result) {
      await swalAlert(result.data.msg);
      clearInterval(timer.timerID); //인증시간 만료
      if (result.data.state == "Y") {
        let param = {};
        param.cellNo = state.phoneNum;
        axios.json("/findPw.do", param).then(async function (pwResult) {
          if (pwResult.data.state == "Y") {
            state.lostPwBcOutputVo = _.flatten([
              pwResult.data.lostPwBcOutputVo,
            ]);
            console.log(state.lostPwBcOutputVo.login_id);
            state.logId = state.lostPwBcOutputVo[0].login_id.trim();
            state.biz_no = state.lostPwBcOutputVo[0].corp_no.substring(0, 10);
            PopPwChangeRef.value.open({
              sType: 1,
              login_id: state.logId,
              biz_no: state.biz_no,
            });
          } else {
            await swalAlert(pwResult.data.msg);
          }
        });
      }
    });
  }
};

//타이머 시작
function start_timer() {
  clearInterval(timer.timerID);
  timer.athHr = timer.athStdHr;
  timer.timerID = setInterval(function () {
    decrementTime();
  }, 1000);
}

const timer = reactive({
  timerFlag: false,
  timerID: "",
  athStdHr: 180, // 인증기준시간
  athHr: 180, // 인증시간
  athInhrNo: "", // 인증고유번호
  remainAthHr: computed(() => toMinSec(timer.athHr)),
});

function decrementTime() {
  if (timer.athHr > 0) {
    timer.athHr--;
  } else {
    clearInterval(timer.timerID); //인증시간 만료
    swalAlert(
      "인증시간이 만료되었습니다.\n\n인증번호 재발송 하신 후 진행하세요."
    );
    timer.timerFlag = false;
  }
}

function toMinSec(t) {
  var hour;
  var min;
  var sec;

  hour = Math.floor(t / 3600);
  min = Math.floor(t / 60);
  sec = t - hour * 3600 - min * 60;
  if (sec < 10) sec = "0" + sec;
  return " " + min + "분 " + sec + "초";
}

init();

async function init() {
  state.getPhoneTypCd = codeList.getPhoneTypCd;

  timer.timerFlag = true;
  //timer.athInhrNo = props.param.athInhrNo;
}
</script>

<style></style>
